import { createContext } from 'react';
export var listInputElementWidthLinesContext = createContext(1);
